<template>
  <b-form-group
    label="Metin"
    label-for="vision_mission_content"
  >
    <validation-provider
      #default="{ errors }"
      name="Metin"
      rules="required"
    >
      <b-form-textarea
        id="vision_mission_content"
        v-model="itemData.vision_mission_content"
        placeholder="Metin"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { BFormGroup, BFormTextarea } from 'bootstrap-vue'

export default {
  name: 'VisionMissionContent',
  components: {
    BFormGroup,
    BFormTextarea,
    ValidationProvider,
  },
  computed: {
    itemData() {
      return this.$store.getters['about/dataItem']
    },
  },
}
</script>
